import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Button from 'modules/_shared/components/Buttons';

type PartnerSocietySharesOffersProps = {
  hasEquityMarketEnabled: boolean;
  hasBuySharesEnabled: boolean;
  hasSellSharesEnabled: boolean;
  isReadOnly: boolean;
  isReadOnlyUser: boolean;
  handleOpenBuyShares: () => void;
  handleOpenSellShares: () => void;
  handleOpenEquityMarket: () => void;
};

const TEMPORARY_DISABLED = false;

const PartnerSocietySharesOffers: FC<PartnerSocietySharesOffersProps> = ({
  hasEquityMarketEnabled,
  hasBuySharesEnabled,
  hasSellSharesEnabled,
  isReadOnly,
  isReadOnlyUser,
  handleOpenBuyShares,
  handleOpenSellShares,
  handleOpenEquityMarket,
}) => {
  const { t } = useTranslate();

  if (
    !hasBuySharesEnabled &&
    !hasSellSharesEnabled &&
    !hasEquityMarketEnabled
  ) {
    return null;
  }

  if (TEMPORARY_DISABLED) {
    return null;
  }

  return (
    <div className="card-inner card-inner-sm px-0">
      <ul className="btn-toolbar justify-center gx-1">
        {hasBuySharesEnabled && (
          <li>
            <Button
              variant="primary"
              outlineStyle
              className="btn btn-outline-primary"
              onClick={handleOpenBuyShares}
              disabled={isReadOnly || isReadOnlyUser}
            >
              <em className="icon ni ni-coins mr-1" />
              {t('ToBuy')}
            </Button>
          </li>
        )}

        {hasSellSharesEnabled && (
          <li>
            <Button
              variant="primary"
              outlineStyle
              onClick={handleOpenSellShares}
              disabled={isReadOnly || isReadOnlyUser}
            >
              <em className="icon ni ni-coins mr-1" />
              {t('ToSell')}
            </Button>
          </li>
        )}

        {hasEquityMarketEnabled && (
          <li>
            <Button
              variant="success"
              onClick={handleOpenEquityMarket}
              outlineStyle={false}
            >
              <em className="icon ni ni-coins mr-1" />
              {t('EquityMarket')}
            </Button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default PartnerSocietySharesOffers;
